import { render, staticRenderFns } from "./InputEditor.vue?vue&type=template&id=06b568b5&scoped=true"
import script from "./InputEditor.vue?vue&type=script&lang=js"
export * from "./InputEditor.vue?vue&type=script&lang=js"
import style0 from "./InputEditor.vue?vue&type=style&index=0&id=06b568b5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b568b5",
  null
  
)

export default component.exports